import { render, staticRenderFns } from "./mylecture.vue?vue&type=template&id=a6354a4a&"
import script from "./mylecture.vue?vue&type=script&lang=js&"
export * from "./mylecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports